module.exports = global["Phaser"] = require("-!.\\phaser-no-physics.js");